import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles, Typography } from './../../../../themes/default';

const styles = theme => ({
  root: {
    display: 'inline-block',
    textDecoration: 'none',
    fontSize: '0.8125rem',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  primary: {
    color: theme.palette.text.primary,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  secondary: {
    color: theme.palette.text.secondary,
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

const Link = ({ children, classes, to, variant, isExrernal }) => {

  let _variant = variant ? classes[variant] : classes['primary'];

  return (
    isExrernal ? (
      <a href={ to } rel="noopener noreferrer" target="_blank" className={ classNames( classes.root, _variant ) }>{ children }</a>
    ) : (
      <Typography component={ NavLink } to={ to } className={ classNames( classes.root, _variant ) }>
        { children }
      </Typography>
    )
  )

}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['contained', 'outlined', 'fab'])
};

export default withStyles(styles)(Link);
